import React, {Component} from 'react';
import PortfolioContent from "../atoms/PortfolioContent";

class PostContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			postData: this.props.postData
		};
	}

	_onClickClose(e){
		this.props.onClick(e);
	}

	render() {
		return (
			<div classID="portfolio-content" className="portfolio-content">
				<div className="reference-content">

					<div className="col-sm-8">

						<PortfolioContent data={this.state.postData}/>

					</div>

					<div className="col-sm-4">

						<p className="s-proj-title">{this.state.postData.post_title}</p>
						<div dangerouslySetInnerHTML={{ __html: this.state.postData.post_content }} />
						<div onClick={this._onClickClose.bind(this)} className="btn btn-default close-project-portfolio" data-close-project="">
							Zavrieť
							album
						</div>

					</div>

				</div>

			</div>
		)
	}


}

export default PostContent;



// WEBPACK FOOTER //
// ./src/component/PostContent.js